import { render, staticRenderFns } from "./SocialTabs.vue?vue&type=template&id=4f3a4c25&"
import script from "./SocialTabs.vue?vue&type=script&lang=js&"
export * from "./SocialTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports